import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessGrantRow } from '@6grain/masofa-monolith-api-client/identity';
import { environment } from '@root/src/environments/environment';

/**
 * Process-scoped grant lookup.
 * TODO: migrate to api-client when AccessControl.ForProcess is generated.
 */
@Injectable({ providedIn: 'root' })
export class AccessProcessGrantsService {
  private readonly http = inject(HttpClient);

  forProcess(processKey: string): Observable<AccessGrantRow[]> {
    const params = new HttpParams().set('processKey', processKey);
    return this.http.get<AccessGrantRow[]>(`${environment.api}/identity/AccessControl/ForProcess`, { params });
  }
}
